module.exports = __webpack_public_path__ + "img/ic-processing.17bb275d.webp";